import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RoomTypeModel } from '@app/catalog';

@Component({
  selector: 'type-item',
  standalone: false,
  templateUrl: './type-item.component.html',
  styleUrl: './type-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TypeItemComponent {
  public type = input.required<RoomTypeModel>();
}
